import React from "react";
import "./Hero.css";
import { BsCheckCircleFill } from "react-icons/bs";
import heroimg from "../AssetProduct/heroimage.png";

const points = [
  "You know where your assets are",
  "Your assets remain productive",
  "Asset information is at your fingertips",
  "Fixed Asset Register is financially accurate",
  "Asset maintenance cost is reduced by 40%",
  "And you are fully compliant",
];

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-overlay"></div>
      <div className="hero-pattern"></div>

      <div className="container mx-auto px-4 pt-12 pb-20 md:pt-16 md:pb-24 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 items-center">
          {/* Left Column */}
          <div className="hero-content">
            <div className="category-badge">Software-as-a-Service</div>

            <h1 className="text-4xl md:text-5xl lg:text-5xl font-bold mb-8 gradient-text">
              {/* iAssetMax™ Application Management */}
              Enterprise Asset Management<br></br>(iAssetMax™)
            </h1>

            <div className="animated-bar"></div>

            <ul className="flex flex-col gap-3.5 mt-6 mb-2">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <BsCheckCircleFill
                    aria-hidden="true"
                    className="mt-1 shrink-0 text-[1.15rem] text-[#F23100]"
                  />
                  <span className="text-lg text-white font-medium text-shadow leading-snug">
                    {p}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Column */}
          <div className="hero-image-container">
            <div className="image-frame">
              <img src={heroimg} alt="iAssetMax™ Application Management" className="rounded-lg" />
              <div className="blob-effect"></div>
              <div className="glow-effect"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Wave divider */}
      <div className="absolute bottom-0 left-0 right-0 w-full overflow-hidden leading-none z-10">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" className="w-full h-12 sm:h-16">
          <defs>
            <linearGradient id="waveGradientAM" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#F23100" />
              <stop offset="100%" stopColor="#ff7a50" />
            </linearGradient>
          </defs>
          <path
            fill="url(#waveGradientAM)"
            d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,100L1360,100C1280,100,1120,100,960,100C800,100,640,100,480,100C320,100,160,100,80,100L0,100Z"
          ></path>
        </svg>
      </div>
    </section>
  );
};

export default Hero;